unit HMRCPromptForm;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  Vcl.Controls,
  Vcl.StdCtrls,
  WEBLib.StdCtrls,
  WEBLib.ExtCtrls;

type
  THMRCPromptForm = class(TForm)
    PromptMessage: TLabel;
    SkipButton: TButton;
    GoToSetupButton: TButton;
    procedure SkipButtonClick(Sender: TObject);
    procedure GoToSetupButtonClick(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

implementation

{$R *.dfm}


procedure THMRCPromptForm.SkipButtonClick(Sender: TObject);
begin
  ModalResult := mrCancel;
end;

procedure THMRCPromptForm.WebFormCreate(Sender: TObject);
begin
  PromptMessage.Caption := 'Charity HMRC setup is required before claims can be submitted.' +
   sLineBreak + 'Please complete your charity and HMRC configuration to submit Gift Aid claims.';
end;

procedure THMRCPromptForm.GoToSetupButtonClick(Sender: TObject);
begin
  ModalResult := mrOK;
end;

procedure THMRCPromptForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  PromptMessage := TLabel.Create('HMRCPromptMessage');
  SkipButton := TButton.Create('HMRCPromptSkipButton');
  GoToSetupButton := TButton.Create('HMRCPromptGoToSetupButton');

  PromptMessage.BeforeLoadDFMValues;
  SkipButton.BeforeLoadDFMValues;
  GoToSetupButton.BeforeLoadDFMValues;
  try
    Name := 'HMRCPromptForm';
    Width := 480;
    Height := 260;
    ElementClassName := 'PopUpForm';
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    PromptMessage.SetParentComponent(Self);
    PromptMessage.Name := 'PromptMessage';
    PromptMessage.Left := 8;
    PromptMessage.Top := 24;
    PromptMessage.Width := 425;
    PromptMessage.Height := 89;
    PromptMessage.AutoSize := False;
    PromptMessage.ElementPosition := epIgnore;
    PromptMessage.HeightStyle := ssAuto;
    PromptMessage.HeightPercent := 100.000000000000000000;
    PromptMessage.WordWrap := True;
    PromptMessage.WidthStyle := ssAuto;
    PromptMessage.WidthPercent := 100.000000000000000000;
    SkipButton.SetParentComponent(Self);
    SkipButton.Name := 'SkipButton';
    SkipButton.Left := 376;
    SkipButton.Top := 208;
    SkipButton.Width := 96;
    SkipButton.Height := 32;
    SkipButton.Caption := 'Skip';
    SkipButton.ElementClassName := 'btn btn-secondary';
    SkipButton.ElementPosition := epIgnore;
    SkipButton.HeightStyle := ssAuto;
    SkipButton.HeightPercent := 100.000000000000000000;
    SkipButton.WidthStyle := ssAuto;
    SkipButton.WidthPercent := 100.000000000000000000;
    SetEvent(SkipButton, Self, 'OnClick', 'SkipButtonClick');
    GoToSetupButton.SetParentComponent(Self);
    GoToSetupButton.Name := 'GoToSetupButton';
    GoToSetupButton.Left := 264;
    GoToSetupButton.Top := 208;
    GoToSetupButton.Width := 96;
    GoToSetupButton.Height := 32;
    GoToSetupButton.Caption := 'Go to setup';
    GoToSetupButton.ElementClassName := 'btn btn-primary';
    GoToSetupButton.ElementPosition := epIgnore;
    GoToSetupButton.HeightStyle := ssAuto;
    GoToSetupButton.HeightPercent := 100.000000000000000000;
    GoToSetupButton.WidthStyle := ssAuto;
    GoToSetupButton.WidthPercent := 100.000000000000000000;
    SetEvent(GoToSetupButton, Self, 'OnClick', 'GoToSetupButtonClick');
  finally
    PromptMessage.AfterLoadDFMValues;
    SkipButton.AfterLoadDFMValues;
    GoToSetupButton.AfterLoadDFMValues;
  end;
end;

end.
